

























import { defineComponent } from "@vue/composition-api";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "StatementItemDetailsTableItem",
  components: {
    FormatMoney,
  },
  props: {
    title: { type: String, required: true },
    gross: { type: Number },
    net: { type: Number, required: true },
    dotColor: { type: String },
    bold: { type: Boolean },
    forceShowGross: { type: Boolean },
  },
});
